import { FieldSwitch } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { ampli } from 'lib-shared-tracking';
import { PureComponent } from 'react';

import { AutomationListingT } from 'hocs/automations/api/types';
import { WithAutomationsInjectedPropsT } from 'hocs/automations/withAutomations';

type ToggleAutomationPropsT = {
  automations: WithAutomationsInjectedPropsT['automations'];
  automation: AutomationListingT;
  disabled: boolean;
};

export class ToggleAutomation extends PureComponent<ToggleAutomationPropsT> {
  @boundMethod
  onChange() {
    const { automation, automations } = this.props;
    const active = !automation.active;

    if (active) {
      ampli.automationsToggledOn();
    } else {
      ampli.automationsToggledOff();
    }

    automations.update(automation.id, { active });
  }

  render() {
    const { automation, disabled } = this.props;

    return (
      <FieldSwitch
        input={{
          name: automation.name,
          value: automation.name,
          checked: automation.active,
          onChange: this.onChange,
          disabled,
        }}
        disabled={disabled}
      />
    );
  }
}
